import * as React from 'react';
import { useId, useMemo } from 'react';
import { useUncontrolledProp } from 'uncontrollable';
import TabContext from './TabContext.js';
import SelectableContext from './SelectableContext.js';
import TabPanel from './TabPanel.js';
import { jsx as _jsx } from "react/jsx-runtime";
const Tabs = props => {
  const {
    id: userId,
    generateChildId: generateCustomChildId,
    onSelect: propsOnSelect,
    activeKey: propsActiveKey,
    defaultActiveKey,
    transition,
    mountOnEnter,
    unmountOnExit,
    children
  } = props;
  const [activeKey, onSelect] = useUncontrolledProp(propsActiveKey, defaultActiveKey, propsOnSelect);
  const generatedId = useId();
  const id = userId != null ? userId : generatedId;
  const generateChildId = useMemo(() => generateCustomChildId || ((key, type) => id ? `${id}-${type}-${key}` : null), [id, generateCustomChildId]);
  const tabContext = useMemo(() => ({
    onSelect,
    activeKey,
    transition,
    mountOnEnter: mountOnEnter || false,
    unmountOnExit: unmountOnExit || false,
    getControlledId: key => generateChildId(key, 'pane'),
    getControllerId: key => generateChildId(key, 'tab')
  }), [onSelect, activeKey, transition, mountOnEnter, unmountOnExit, generateChildId]);
  return /*#__PURE__*/_jsx(TabContext.Provider, {
    value: tabContext,
    children: /*#__PURE__*/_jsx(SelectableContext.Provider, {
      value: onSelect || null,
      children: children
    })
  });
};
Tabs.Panel = TabPanel;
export default Tabs;